import React from "react"
import Background from "../images/VaccinVirus.jpg"


function Top (props){

  const topStyle ={
    height: '80vh',
    backgroundImage: `url(${Background})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
  
  }
  
  const h1Style ={
    color: 'white',
    fontWeight: 'bold',
    border: 'thick solid #F4ECEA',
    padding: '8vh',
    fontSize: '8vh',
  
  }
  
  return(
    <div className="container-fluid">
      <div style={topStyle} className="row justify-content-center align-items-center">
        <div className="col text-center">
          <h1 style={h1Style}> Molecular Virology Lab </h1>
        </div>
        
      </div>
      
    </div>
  )
}

export default Top